<template>
  <validation-provider
    :name="name"
    :rules="validate"
    v-slot="{ errors, invalid, validated }"
    :mode="validateMode"
  >
    <vvs-control-wrapper
      :label="label"
      :description="description"
      :is-required="isRequired"
      :loading="loading"
      :error="errors[0]"
      :normal-label="normalLabel"
    >
      <div class="vvns-checkbox">
        <label class="vvns-checkbox__label d-block cursor-pointer">
          <input
            v-model="proxy"
            class="vvns-checkbox__input"
            @change="onInput"
            type="checkbox"
            v-bind="formControlOptions"
          />
          <slot name="checkmark">
            <span
              class="vvns-checkbox__checkmark"
              :class="{ error: validated && invalid }"
            ></span>
          </slot>
          <slot>{{ label }}</slot>
        </label>
      </div>
    </vvs-control-wrapper>
  </validation-provider>
</template>

<script>
import formControlMixin from '@/mixins/form.control.mixin';

export default {
  name: 'VvsGeneralCheckbox',
  mixins: [formControlMixin],
  props: {
    small: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
